﻿import { RESTError } from "../RESTError";

var BASE_URL = '/api/Session';

export function getCurrentUser(callback: (err: RESTError, data: UserAccount) => any): void {
    $.ajax(BASE_URL + '', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 30000,
        success: (data: UserAccount, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR), null);
        }
    });
}

export function login(email: string, password: string, callback: (RESTError: any) => any): void {
    $.ajax(BASE_URL + '', {
        cache: false,
        type: 'POST',
        data: {
            "Email": email,
            "Password": password
        },
        timeout: 30000,
        success: (data: any, text: string, jqXHR: JQueryXHR) => {
            callback(null);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(new RESTError(jqXHR));
        }
    });
}